import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const AlertBase = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  font-size: 13px;
  padding: 11px;
  border-radius: 4px;
  margin-bottom: 20px;
`;

export const AlertWarning = styled(AlertBase)`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfaceAccentEmphasisLowWarning)};
`;

AlertWarning.displayName = "AlertWarning";

export const AlertSuccess = styled(AlertBase)`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfaceAccentEmphasisLowPositive)};
`;

AlertSuccess.displayName = "AlertSuccess";

export const AlertDanger = styled(AlertBase)`
  background: ${withVar(DesignToken.SurfaceAccentEmphasisLowNegative)};
`;

AlertDanger.displayName = "AlertDanger";
